import * as Rx from 'rxjs';
import { filter, map } from 'rxjs/operators';
var RequestStatusHandler = /** @class */ (function () {
    function RequestStatusHandler() {
        this._statusStreamSubject$ = new Rx.Subject();
    }
    Object.defineProperty(RequestStatusHandler.prototype, "statusStream$", {
        get: function () {
            return this._statusStreamSubject$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    RequestStatusHandler.prototype.get$ = function (request) {
        return this._statusStreamSubject$.pipe(filter(function (e) {
            return e.request.clientRequestIds.some(function (id) {
                return request.clientRequestIds.includes(id);
            });
        }), map(function (e) { return e.statusObject; }));
    };
    RequestStatusHandler.prototype.update = function (request, status) {
        this._statusStreamSubject$.next({
            request: request,
            statusObject: status,
        });
    };
    return RequestStatusHandler;
}());
export { RequestStatusHandler };
export function requestStatusesEqual(a, b) {
    return (
    // Plain ready flag, no error
    (a.ready === b.ready && !a.error && !b.error) ||
        // Not ready, error codes equal
        (!a.ready &&
            !b.ready &&
            !!a.error &&
            !!b.error &&
            a.error.errorCode === b.error.errorCode));
}
